import React from "react";
import { Link } from "react-router-dom";

const HeaderBar = () => (
  <div className="bg-[#333] text-white text-sm py-2 px-4 flex flex-col md:flex-row md:justify-between items-center gap-2 text-center">
    <a href="mailto:admin@kentacademy.co.uk" className="hover:underline">
      📧 admin@kentacademy.co.uk
    </a>
    <a
      href="https://www.facebook.com/share/16qS8YJbJc/?mibextid=wwXIfr"
      target="_blank"
      rel="noopener noreferrer"
      className="text-white hover:underline flex items-center gap-1"
    >
      <img src="/assets/facebook-icon.png" alt="Facebook" className="w-5 h-5" />
      facebook.com/KentAcademy
    </a>
  </div>
);

const SiteNav = () => (
  <nav className="bg-white shadow-sm w-full z-50 border-b border-gray-200">
    <div className="max-w-7xl mx-auto px-4 pt-6 pb-4 flex items-center justify-center">
      <Link to="/">
        <img
          src="/assets/KaLogo.png"
          alt="Kent Academy"
          className="h-40 w-auto object-contain"
        />
      </Link>
    </div>
  </nav>
);

export default function Level3Tasks() {
  return (
    <div className="bg-[#f7f6f3] text-gray-800 min-h-screen">
      <HeaderBar />
      <SiteNav />

      <main className="max-w-6xl mx-auto px-6 py-16">
        <div className="bg-white rounded-2xl shadow p-8 border border-gray-100 text-center">
          <h1 className="text-3xl md:text-4xl font-light mb-6">
            NEXT STEPS / CÁC BƯỚC TIẾP THEO
          </h1>

          <p className="text-lg mb-6">
            Thank you for enrolling on to Level 3 in Nail Technology with Kent
            Academy. <br />
            Please contact us on <strong>07735 906672</strong> to discuss the
            next steps.
            <br />
            <br />
            Xin hãy bấm vào đây <br />
            Cảm ơn bạn đã đăng ký khóa học Nails Level 3 với trường Kent
            Academy. <br />
            Làm ơn liên lạc với chúng tôi qua số điện thoại{" "}
            <strong>07735 906672</strong> để thảo luận về các bước tiếp theo.
            <br />
            <br />
            Xin cảm ơn <br />
            Kent Academy
          </p>

          <Link to="/courses/level-3/welcome" className="underline">
            ← Back to Welcome / Về trang chào mừng
          </Link>
        </div>
      </main>

      <footer className="bg-[#333] text-white py-12">
        <div className="max-w-6xl mx-auto px-6 text-center text-xs text-gray-300">
          © {new Date().getFullYear()} Kent Academy. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
